import React from "react";
import { createRoot } from "react-dom/client";
import camelcaseKeys from "camelcase-keys";
import "@givecampus/ui/fonts";
import parseDataset from "@/shared/utils/parseDataset";
import { FeatureFlagsProvider } from "@/shared/FeatureFlagsContext";
import { initFlashDismissal } from "@/shared/utils/flashDismissal";

window.loadComponents = async (rootElement) => {
  const elements = rootElement.querySelectorAll("[data-component]");

  elements.forEach(async element => {
    const filename = element.dataset.component;

    const Component = await import(`../react_frontend/${filename}`);

    const data = camelcaseKeys(parseDataset(element.dataset), { deep: true });
    const flags = camelcaseKeys(
      JSON.parse(element.dataset.featureFlags || "{}"),
      { deep: false }
    );

    createRoot(element).render(
      React.createElement(
        FeatureFlagsProvider,
        { flags },
        React.createElement(Component.default, data.props)
      )
    );
  });
};

document.addEventListener("DOMContentLoaded", () => {
  window.loadComponents(document);
  initFlashDismissal();
});
